import React from 'react'
import Typography from '@material-ui/core/Typography'

const SectionTitle = ({ label }) => 
  <Typography variant="h6" gutterBottom>
    {label}
  </Typography>

export default SectionTitle
